import React from "react";
import { CommonModal } from "../../../AbstractElements";
import { Row, Col } from "reactstrap";
import { showAlert } from "../../../Services/Shared.service";
import { retrieveDriver } from "../../../Services/Driver.service";

const RetrieveConfirmationModal = ({ Large, title, LargeModaltoggle, driverObj, fetchData, filterData, searchData, }) => {
    const onRetrieveSubmit = () => {
        retrieveDriver(driverObj.id).then(async (result) => {
            showAlert('success', "Driver Retrieved successfully")
            if (filterData.length > 0 || searchData) {
                setTimeout(async () => {
                    await fetchData()
                }, 3000)
            } else {
                await fetchData()
            }
            LargeModaltoggle();
        }).catch(err => {
            showAlert('error', err.response?.data?.message
                ? err.response.data.message : 'Something went wrong')
        })
    };
    return (
        <CommonModal
            isOpen={Large}
            title={title}
            toggler={LargeModaltoggle}
            size="md"
        >
            <Row className="driver-push-notification">
                <Col xl="12" className="push-botification-body">
                    <div className="text-center">Are you sure you want to retrieve this driver ?</div>
                </Col>
                <Col xl="12" className="push-notification-footer">
                    <button
                        className="btn btn-primary"
                        type="submit"
                        onClick={() => onRetrieveSubmit()}
                    >
                        Confirm
                    </button>
                </Col>
            </Row>
        </CommonModal>
    );
};

export default RetrieveConfirmationModal;
